export interface Location {
  id: string;
  name: string;
  address: string;
  mapUrl?: string;
  district: string;
  phone: string;
  hours: string;
  features: string[];
  coordinates: {
    lat: number;
    lng: number;
  };
  image: string;
  description: string;
}

export const locations: Location[] = [
  {
    id: 'selva-alegre',
    name: 'Pepe Tiburón Selva Alegre',
    address: 'Av. España 249, con calle Los Andes',
    mapUrl: 'https://maps.app.goo.gl/VYQdSV6fZqBaxLvq9',
    district: 'Selva Alegre',
    phone: '958 555 183',
    hours: 'Lun - Dom: 10:00 AM - 5:00 PM',
    features: ['Ceviche', 'Mariscos', 'Delivery', 'Para llevar'],
    coordinates: {
      lat: -16.3948,
      lng: -71.5319
    },
    image: `${process.env.PUBLIC_URL}/ceviche.jpg`,
    description: 'Frescura del mar en el corazón de Selva Alegre.'
  },
  {
    id: 'cayma-micaela-bastidas',
    name: 'Pepe Tiburón Cayma (Micaela Bastidas)',
    address: 'Calle Micaela Bastidas 149, con calle Sucre (La Tomilla)',
    mapUrl: 'https://maps.app.goo.gl/zGj1DPiR4RjzZxZdA',
    district: 'Cayma',
    phone: '921 024 290',
    hours: 'Lun - Dom: 10:00 AM - 5:00 PM',
    features: ['Ceviche', 'Mariscos', 'Delivery', 'Ambiente familiar'],
    coordinates: {
      lat: -16.4019,
      lng: -71.5289
    },
    image: `${process.env.PUBLIC_URL}/mixto.jpg`,
    description: 'Sede en Cayma para disfrutar ceviches y mariscos con el sabor de la casa.'
  },
  {
    id: 'cayma-ramon-castilla',
    name: 'Pepe Tiburón Cayma (Ramón Castilla)',
    address: 'Av. Ramón Castilla 894',
    mapUrl: 'https://maps.app.goo.gl/PBbsD6QbXs64owzN9',
    district: 'Cayma',
    phone: '917 507 867',
    hours: 'Lun - Dom: 10:00 AM - 5:00 PM',
    features: ['Ceviche', 'Mariscos', 'Delivery', 'Para llevar'],
    coordinates: {
      lat: -16.3988,
      lng: -71.5369
    },
    image: `${process.env.PUBLIC_URL}/arroz.jpg`,
    description: 'Sede en Av. Ramón Castilla para disfrutar lo mejor del mar.'
  },
  {
    id: 'cercado',
    name: 'Pepe Tiburón Cercado',
    address: 'Calle Mercaderes 404, 3° piso (terraza)',
    mapUrl: 'https://maps.app.goo.gl/b27nge3ZynhrHFud7',
    district: 'Cercado de Arequipa',
    phone: '',
    hours: 'Lun - Dom: 10:00 AM - 5:00 PM',
    features: ['Terraza', 'Centro', 'Ceviche', 'Mariscos'],
    coordinates: {
      lat: -16.3988,
      lng: -71.5369
    },
    image: `${process.env.PUBLIC_URL}/chop.jpeg`,
    description: 'Ubicado en pleno centro, ideal para comer en terraza.'
  }
];